import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { normalizePermissions } from "./normalizePermissions";

export const fetchUserPermissions = createAsyncThunk(
  "auth/userPermissions",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token =
        getState()?.user?.accessToken || localStorage.getItem("accessToken");
      if (!token) {
        return rejectWithValue({ error: "Missing token." });
      }

      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/userPermissions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const payload = res.data || {};
      const normalizedSource =
        payload.permissions && typeof payload.permissions === "object"
          ? payload.permissions
          : payload;
      return {
        ...payload,
        permissions: normalizePermissions(normalizedSource),
      };
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const fetchPermissionCatalog = createAsyncThunk(
  "auth/permissionCatalog",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token =
        getState()?.user?.accessToken || localStorage.getItem("accessToken");
      if (!token) {
        return rejectWithValue({ error: "Missing token." });
      }

      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/permission-catalog`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("perm",res)
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);
